import React, { Fragment } from 'react';

type conditionalWrapperType = {
  visible: boolean;
  children?: React.ReactNode;
};
export const ConditionalWrapper: React.FC<conditionalWrapperType> = ({ visible, children }) => {
  return visible ? <Fragment>{children}</Fragment> : <Fragment />;
};
